import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants'

export default (theme: APTheme) => createStyles({
	tableSkeleton: {
		display: 'flex',
		'@media(max-width: 990px)': {
			display: 'block',
		}
	},
	tableSkeletonContainer: {
		flex: 1,
		alignItems: 'center',
		padding: '34px 35px',
		marginRight: 30,
		borderRadius: 3,
		'&:last-child': {
			marginRight: 0,
		},
		'@media(max-width: 1300px)': {
			marginRight: 15,
			'&:last-child': {
				marginRight: 0,
			},
		},
		'@media(max-width: 1200px)': {
			paddingLeft: 110
		},
		'@media(max-width: 990px)': {
			minHeight: 58,
			margin: '0 0 10px 0',
			paddingLeft: 110,
			'&:last-child': {
				marginBottom: 0
			},
		},
		'@media(max-width: 768px)': {
			paddingLeft: 30
		}
	},
	tableContainer: {
		'& > table': {
			border: '1px solid rgba(224, 224, 224, 1)',
			borderBottom: 'none'
		}
	},
	tableCell: {
		fontSize: 16,
		padding: 20,
		'&:first-child': {
			fontWeight: 500
		},
		'&:last-child > span': {
			justifyContent: 'flex-end'
		},
		'&.isResponsive': {
			width: 'auto',
			padding: '0',
			position: 'relative',
			fontSize: 14,
			display: 'grid',
			gridTemplateColumns: '10em auto',
			justifyItems: 'stretch',
			border: 'none',
			marginBottom: 5,
			'&:before': {
				content: 'attr(data-label)',
				fontWeight: 500,
			},
			'&:last-child': {
				marginBottom: 0,
				'& > span': {
					justifyContent: 'flex-start',
				},
			}
		}
	},
	tableHeadingCell: {
		color: '#4A4A4A',
		fontSize: 18,
		fontWeight: 500,
		backgroundColor: '#fff', // TODO - Get hex colour codes from constant style variables
		borderBottom: '1px solid rgba(224, 224, 224, 1)',
		padding: 0
	},
	searchTableHeadingCell: {
		padding: '18px 30px',
		lineHeight: '25px'
	},
	searchDataTableHeadingCellSpan: {
		fontSize: 18,
		fontWeight: 700
	},
	accountContainer: {
		background: '#F5F5F5', // TODO - Get hex colour codes from constant style variables
		color: '#4a4a4a', // TODO - Get hex colour codes from constant style variables
		fontSize: 16,
		letterSpacing: '-0.5px',
		height: '100%',
		padding: '34px 35px',
		animationName: `$onloadup`,
		animationDuration: '0.3s',
		animationFillMode: 'both',
		animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
		'@media(max-width: 768px)': {
			padding: 30,
		},
		'@media(max-width: 480px)': {
			padding: 20,
		}
	},
	formSectionRadio: {
		color: '#4A4A4A', // TODO - Get hex colour codes from constant style variables
		display: 'inline-block',
		flexDirection: 'row',
		float: 'right',
		'& .MuiSvgIcon-root': {
			fill: theme.palette.primary.main,
			fontSize: '2.6rem'
		},
		'& .MuiFormControlLabel-root:first-child': {
			marginRight: 16,
			marginLeft: 0
		},
		'& .MuiFormControlLabel-root:last-child': {
			marginLeft: 15,
			marginRight: 0,
		},
		'& .MuiIconButton-root': {
			padding: "0px 10px 0px 0px",
			'& .APRadio-icon': {
				width: 20,
				height: 20
			}
		},
		'& .MuiTypography-body1': {
			lineHeight: '18px'
		},
		'&.isResponsive': {
			'@media(max-width: 620px)': {
				float: 'left',
				display: 'block',
				width: '100%'
			},
			'& .MuiFormControlLabel-root:last-child': {
				marginLeft: 11
			}
		}
	}
});
